<script setup lang="ts">
interface Props {
    icon: string
    title: string
}

const props = defineProps<Props>()

const prefix: string = import.meta.env.VITE_ENVIRONMENT === 'prod' ? '/img' : '../public/img'
</script>

<template>
    <div
        class="flex h-[120px] flex-col justify-between rounded-3xl bg-surface-100 p-4 text-left text-body-16 text-surface-800 md:h-[230px] md:w-[250px] md:p-6">
        <div class="flex flex-col gap-2.5">
            <div class="text-desk-h5">{{ props.title }}</div>
            <slot />
        </div>
        <img
            class="h-8 w-8 self-end text-icon md:h-10 md:w-10"
            :src="`${prefix}/${props.icon}.svg`" />
    </div>
</template>
